// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  box-sizing:border-box;
  font-family:'Outfit',sans-serif;
}

.newclientform_overlay{
  position:fixed;
  inset:0;
  background:rgba(15,23,42,.55);
  backdrop-filter:blur(6px);
  display:flex;
  justify-content:center;
  align-items:center;
  z-index:9999;
  padding:20px;
}

.newclientform_modal{
  width:75%;
  max-width:900px;
  height:85vh;
  overflow-y:auto;
  background:#fff;
  border-radius:18px;
  box-shadow:0 25px 70px rgba(0,0,0,.18);
}

.newclientform_header{
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:18px 25px;
  border-bottom:1px solid #edf2f7;
  position:sticky;
  top:0;
  background:#fff;
  z-index:10;
}

.newclientform_title{
  font-size:24px;
  font-weight:700;
  color:#111827;
}

.newclientform_close_btn{
  width:38px;
  height:38px;
  border:none;
  border-radius:50%;
  background:#f3f4f6;
  cursor:pointer;
}

.newclientform_close_btn:hover{
  background:#ef4444;
  color:#fff;
}

.newclientform_grid{
  padding:22px;
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:18px 22px;
}

.newclientform_group{
  display:flex;
  flex-direction:column;
}

.newclientform_label{
  font-size:14px;
  font-weight:600;
  color:#374151;
  margin-bottom:8px;
}

.newclientform_input,
.newclientform_select{
  width:100%;
  height:42px;
  border:1px solid #dbe2ea;
  border-radius:10px;
  padding:0 12px;
  background:#fafafa;
}

.newclientform_input:focus,
.newclientform_select:focus{
  outline:none;
  border-color:#2563eb;
  background:#fff;
  box-shadow:0 0 0 4px rgba(37,99,235,.08);
}

.newclientform_remarks_section{
  padding:0 22px 20px;
}

.newclientform_textarea{
  width:100%;
  height:120px;
  border:1px solid #dbe2ea;
  border-radius:10px;
  padding:12px;
  resize:none;
}

.newclientform_upload_section{
  padding:0 22px 22px;
  display:grid;
  grid-template-columns:repeat(2,1fr);
  gap:16px;
}

.newclientform_upload_card{
  min-height:90px;
  border:2px dashed #dbe2ea;
  border-radius:14px;
  background:#fafafa;
  display:flex;
  justify-content:center;
  align-items:center;
  transition:.3s;
}

.newclientform_upload_card:hover{
  border-color:#2563eb;
  background:#f8fbff;
}

.newclientform_hidden_file{
  display:none;
}

.newclientform_upload_label{
  width:100%;
  height:100%;
  display:flex;
  justify-content:center;
  align-items:center;
  cursor:pointer;
  font-size:15px;
  font-weight:600;
  color:#2563eb;
}

.newclientform_button_section{
  display:flex;
  justify-content:flex-end;
  gap:12px;
  padding:18px 22px;
  border-top:1px solid #edf2f7;
  position:sticky;
  bottom:0;
  background:#fff;
}

.newclientform_save_btn{
  min-width:120px;
  height:42px;
  border:none;
  border-radius:10px;
  background:#2563eb;
  color:#fff;
  font-weight:600;
  cursor:pointer;
}

.newclientform_cancel_btn{
  min-width:120px;
  height:42px;
  border:none;
  border-radius:10px;
  background:#e5e7eb;
  color:#111827;
  font-weight:600;
  cursor:pointer;
}

@media(max-width:768px){

  .newclientform_modal{
    width:95%;
    height:92vh;
  }

  .newclientform_grid{
    grid-template-columns:1fr;
  }

  .newclientform_upload_section{
    grid-template-columns:1fr;
  }
}
.newclientform_upload_section{
  padding:0 22px 22px;

  display:grid;

  grid-template-columns:
  repeat(3,1fr);

  gap:16px;
}

@media(max-width:768px){

  .newclientform_upload_section{
    grid-template-columns:1fr;
  }

}`, "",{"version":3,"sources":["webpack://./src/styles/newclientform.css"],"names":[],"mappings":"AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,OAAO;EACP,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,KAAK;EACL,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mCAAmC;EACnC,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,mBAAmB;;EAEnB,YAAY;;EAEZ;eACa;;EAEb,QAAQ;AACV;;AAEA;;EAEE;IACE,yBAAyB;EAC3B;;AAEF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');\n\n*{\n  box-sizing:border-box;\n  font-family:'Outfit',sans-serif;\n}\n\n.newclientform_overlay{\n  position:fixed;\n  inset:0;\n  background:rgba(15,23,42,.55);\n  backdrop-filter:blur(6px);\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  z-index:9999;\n  padding:20px;\n}\n\n.newclientform_modal{\n  width:75%;\n  max-width:900px;\n  height:85vh;\n  overflow-y:auto;\n  background:#fff;\n  border-radius:18px;\n  box-shadow:0 25px 70px rgba(0,0,0,.18);\n}\n\n.newclientform_header{\n  display:flex;\n  justify-content:space-between;\n  align-items:center;\n  padding:18px 25px;\n  border-bottom:1px solid #edf2f7;\n  position:sticky;\n  top:0;\n  background:#fff;\n  z-index:10;\n}\n\n.newclientform_title{\n  font-size:24px;\n  font-weight:700;\n  color:#111827;\n}\n\n.newclientform_close_btn{\n  width:38px;\n  height:38px;\n  border:none;\n  border-radius:50%;\n  background:#f3f4f6;\n  cursor:pointer;\n}\n\n.newclientform_close_btn:hover{\n  background:#ef4444;\n  color:#fff;\n}\n\n.newclientform_grid{\n  padding:22px;\n  display:grid;\n  grid-template-columns:repeat(3,1fr);\n  gap:18px 22px;\n}\n\n.newclientform_group{\n  display:flex;\n  flex-direction:column;\n}\n\n.newclientform_label{\n  font-size:14px;\n  font-weight:600;\n  color:#374151;\n  margin-bottom:8px;\n}\n\n.newclientform_input,\n.newclientform_select{\n  width:100%;\n  height:42px;\n  border:1px solid #dbe2ea;\n  border-radius:10px;\n  padding:0 12px;\n  background:#fafafa;\n}\n\n.newclientform_input:focus,\n.newclientform_select:focus{\n  outline:none;\n  border-color:#2563eb;\n  background:#fff;\n  box-shadow:0 0 0 4px rgba(37,99,235,.08);\n}\n\n.newclientform_remarks_section{\n  padding:0 22px 20px;\n}\n\n.newclientform_textarea{\n  width:100%;\n  height:120px;\n  border:1px solid #dbe2ea;\n  border-radius:10px;\n  padding:12px;\n  resize:none;\n}\n\n.newclientform_upload_section{\n  padding:0 22px 22px;\n  display:grid;\n  grid-template-columns:repeat(2,1fr);\n  gap:16px;\n}\n\n.newclientform_upload_card{\n  min-height:90px;\n  border:2px dashed #dbe2ea;\n  border-radius:14px;\n  background:#fafafa;\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  transition:.3s;\n}\n\n.newclientform_upload_card:hover{\n  border-color:#2563eb;\n  background:#f8fbff;\n}\n\n.newclientform_hidden_file{\n  display:none;\n}\n\n.newclientform_upload_label{\n  width:100%;\n  height:100%;\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  cursor:pointer;\n  font-size:15px;\n  font-weight:600;\n  color:#2563eb;\n}\n\n.newclientform_button_section{\n  display:flex;\n  justify-content:flex-end;\n  gap:12px;\n  padding:18px 22px;\n  border-top:1px solid #edf2f7;\n  position:sticky;\n  bottom:0;\n  background:#fff;\n}\n\n.newclientform_save_btn{\n  min-width:120px;\n  height:42px;\n  border:none;\n  border-radius:10px;\n  background:#2563eb;\n  color:#fff;\n  font-weight:600;\n  cursor:pointer;\n}\n\n.newclientform_cancel_btn{\n  min-width:120px;\n  height:42px;\n  border:none;\n  border-radius:10px;\n  background:#e5e7eb;\n  color:#111827;\n  font-weight:600;\n  cursor:pointer;\n}\n\n@media(max-width:768px){\n\n  .newclientform_modal{\n    width:95%;\n    height:92vh;\n  }\n\n  .newclientform_grid{\n    grid-template-columns:1fr;\n  }\n\n  .newclientform_upload_section{\n    grid-template-columns:1fr;\n  }\n}\n.newclientform_upload_section{\n  padding:0 22px 22px;\n\n  display:grid;\n\n  grid-template-columns:\n  repeat(3,1fr);\n\n  gap:16px;\n}\n\n@media(max-width:768px){\n\n  .newclientform_upload_section{\n    grid-template-columns:1fr;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
